var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M849.067 550.4c4.267-8.533 4.267-21.333 0-34.133-4.267-4.267-4.267-8.533-8.533-12.8L541.867 204.8c-17.067-17.067-42.667-17.067-59.733 0s-17.067 42.667 0 59.733l226.133 226.133H213.334c-25.6 0-42.667 17.067-42.667 42.667S187.734 576 213.334 576h494.933L482.134 802.133c-17.067 17.067-17.067 42.667 0 59.733 8.533 8.533 21.333 12.8 29.867 12.8s21.333-4.267 29.867-12.8l298.667-298.667c4.267-4.267 8.533-8.533 8.533-12.8z"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
